import { React, useState, useEffect, useRef, useCallback } from "react";

// Daily games

import ListItem from "./ListItem.tsx";
import Timer from "./Timer.tsx";

export function useKeyboardShortcut({ key, onKeyPressed }) {
  useEffect(() => {
    function keyDownHandler(e: globalThis.KeyboardEvent) {
      if (e.key === key) {
        e.preventDefault();
        onKeyPressed();
      }
    }

    docRef.current.addEventListener("keydown", keyDownHandler);

    return () => {
      docRef.current.removeEventListener("keydown", keyDownHandler);
    };
  }, []);
}

export default function List() {
  const [state, setState] = useState(10);

  console.log("*** State is", state);

  const docRef = useRef(document);

  var enterPressed = useCallback(() => {
    var item = nextUnclickedItem();
    setState(state + 1);
    if (item) {
      clicked(item);
    } else {
      alert("All done!");
    }
  });

  useEffect(() => {
    function keyDownHandler(e: globalThis.KeyboardEvent) {
      if (e.key === "Enter") {
        e.preventDefault();
        enterPressed();
      }
    }

    docRef.current.addEventListener("keydown", keyDownHandler);

    return () => {
      docRef.current.removeEventListener("keydown", keyDownHandler);
    };
  }, []);

  var URLS = [
    ["Decodex", "https://www.playdecodex.com/"],
    ["Raddle", "https://raddle.quest/"],
    ["sudoku", "https://www.nytimes.com/puzzles/sudoku"],
    // ["eightile", "https://eightile.com/"],
    ["tightrope", "https://www.britannica.com/quiz/tightrope"],
    ["alphaguess", "https://alphaguess.com/"],
    ["noun sense", "https://daily.gametje.com/nounsense/"],
    //["quickflip", "https://puzzmallow.com/quickflip"],
    //["collections", "https://puzzmallow.com/collections"],
    //["couplit", "https://couplit.io/"],
    // ["sqnces", "https://sqnces.com/"],
    //["word-loop", "https://word-loop.com/"],
    // ["Omniword", "https://www.omiword.com/"],
    ["daily-sudoku", "https://sudoku.com/challenges"],
    ["buzzled", "https://puzzmallow.com/buzzled"],
    ["bells", "https://puzzmallow.com/bells"],
    ["pipcross", "https://puzzmallow.com/pipcross"],
    // ["dodeku", "https://dodeku.com/"],
    ["wordle", "https://www.nytimes.com/games/wordle/index.html"],
    ["quordle", "https://www.merriam-webster.com/games/quordle/#/"],
    ["octordle", "https://www.merriam-webster.com/games/octordle/"],
    ["duotrigordle", "https://duotrigordle.com/"],
  ];

  var getState = () => {
    var init = {};
    URLS.map((item) => (init[item[0]] = localStorage.getItem(item[0])));
    return init;
  };

  function setLastLeft() {
    console.log("Setting lastLeft", Date.now());
    localStorage.setItem(LASTLEFT, Date.now());
  }

  const LASTLEFT = "lastLeft";

  var lastLeft = localStorage.getItem(LASTLEFT);

  const MINUTE = 6000;

  var nextUnclickedItem = () => {
    console.log("getState", JSON.stringify(getState()));
    for (var item of URLS) {
      if (!localStorage.getItem(item[0])) {
        return item;
      }
    }
    return null;
  };

  if (false && lastLeft) {
    var ago = Date.now() - lastLeft;
    console.log("ago", ago);
    if (ago < 30 * MINUTE && ago > MINUTE) {
      // choose the next thing...
      var item = nextUnclickedItem();
      if (item) {
        console.log("opening", item[0]);
        setLastLeft();
        // setTimeout(() => clicked(item), 3000);
      } else {
        console.log("could not find next unlicked item");
      }
    }
  }

  var reset = (item) => {
    var urls = URLS;
    if (item) {
      urls = [[item]];
    }

    urls.map((item) => localStorage.setItem(item[0], ""));
    setState(state + 1);
  };

  var clicked = (i) => {
    console.log("list clicked", i, state);
    localStorage.setItem(i[0], "1");
    setState(state + 1);
    setLastLeft();
    if (window.location.port != "1234") {
      console.log("opening", i[1]);
      window.open(i[1], "_self");
    }
  };

  return (
    <>
      <ul id="List">
        {URLS.map((item, index) => {
          // console.log(index, "--", state[item[0]]);
          return (
            <li key={index + state}>
              <ListItem
                junk={state}
                visited={localStorage.getItem(item[0])}
                item={item}
                onClick={() => {
                  clicked(item);
                }}
              />
            </li>
          );
        })}
      </ul>
      <Timer atMidnight={() => reset()} at7PM={() => reset("sudoku")} />
      <button onClick={() => reset()}>Reset</button>
      <button onClick={() => reset("sudoku")}>7PM</button>
      <div>{localStorage.getItem(LASTLEFT)}</div>
    </>
  );
}
